module.exports = __webpack_public_path__ + "static/blog-img13-4496df515cf11e5752e1c3eba8ed67ad.jpg";